export var ConsultationUploadType;
(function (ConsultationUploadType) {
    ConsultationUploadType["requiredLabs"] = "required_labs";
})(ConsultationUploadType || (ConsultationUploadType = {}));
